import { Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-questionInf-rating',
  templateUrl: './question-inf-rating.component.html',
  styleUrls: ['./question-inf-rating.component.scss']
})
export class QuestionInfRatingComponent implements OnInit {
  @Input() informantForm: FormGroup;
  @Input() isEditValue: boolean;
  @Input() questionIndex: number;

  @Output() sendArr = new EventEmitter();
  informantArray: any[] = []
  modalData: any;
  value: number;
  options: Options;

  ratingLength = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    this.informantForm.get('default').setValue(1);
    if (!this.isEditValue) {
      this.modalData.informant_tag.forEach(e => {
        this.informantArray.push({
          tag: e,
          type: 'rating',
          question: '',
          length: '',
          default: 1, // ตอนแรกมีให้เลือก แต่เอาออกแล้วเลยใส่ค่า default เป็น 1
          choices: [],
        })
      });
    } else {
      let val_informant = JSON.parse(this.modalData.value.VALUE_INFORMANT);
      val_informant.splice(0, 1);
      this.informantArray = val_informant;

      for (let i = 0; i < this.modalData.value.VALUE[0].choices.length; i++) {
        this.informantFormArray.push(
          this.fb.group({
            choice_id: [this.modalData.value.VALUE[0].choices[i].choice_id],
            choice_detail: [this.modalData.value.VALUE[0].choices[i].choice_detail]
          })
        )
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (changes.questionIndex) {
      // ดำเนินการอัปเดตตามต้องการที่นี่
      this.questionIndex = parseInt(changes.questionIndex.currentValue);
    }
  }

  addLength() {
    this.informantFormArray.clear();
    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      inf.length = this.informantForm.value.length;
      inf.choices = []
    }

    console.log(this.informantArray);

    if (this.informantForm.value.length > 7) {
      for (let i = 0; i < 2; i++) {
        this.informantFormArray.push(
          this.fb.group({
            choice_id: [i + 1],
            choice_detail: ['']
          })
        )

        for (let j = 0; j < this.informantArray.length; j++) {
          const inf = this.informantArray[j];
          inf.choices.push({
            choice_id: i + 1,
            choice_detail: ''
          })
        }
      }

      this.value = Math.ceil(this.informantForm.value.length / 2);
      this.options = {
        floor: 1,
        ceil: this.informantForm.value.length,
        step: 1,
        showTicks: true,
        showTicksValues: false
      }
    } else {
      for (let i = 0; i < this.informantForm.value.length; i++) {
        this.informantFormArray.push(
          this.fb.group({
            choice_id: [i + 1],
            choice_detail: ['']
          })
        )

        for (let j = 0; j < this.informantArray.length; j++) {
          const inf = this.informantArray[j];
          inf.choices.push({
            choice_id: i + 1,
            choice_detail: ''
          })
        }

      }
    }
  }

  get informantFormArray(): FormArray {
    return this.informantForm.get('choices') as FormArray;
  }

  copyArr() {
    console.log(this.informantArray);
    this.sendArr.emit(this.informantArray);
  }

  setQuestionInformant(question) {
    this.informantArray.forEach((el, i) => {
      if (!el.question) {
        el.question = question;
      }
    });
  }

  setChoiceInformant(choice, index) {
    this.informantArray.forEach((el, i) => {
      if (!el.choices[index].choice_detail) {
        el.choices[index].choice_detail = choice;
      }
    });
  }
}
